import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalIssueNavigatorBrowseRoute: InvariantJiraRoute = {
	name: 'legacy-gin-issue',
	path: '/browse/:issueKey?',
	query: ['jql|filter'],
};
